// PaymentSuccess.js
import React from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const PaymentSuccess = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-green-100 via-white to-green-200 px-4 pt-2 pb-4 sm:pt-10 sm:px-3 rounded-2xl">

      <FaCheckCircle className="text-6xl sm:text-7xl text-green-500 animate-bounce mb-3" />

      <h1 className="text-3xl sm:text-4xl font-bold text-green-700 text-center mb-2">
        Payment Successful!
      </h1>

      <p className="text-base sm:text-lg text-gray-700 text-center max-w-md mb-6">
        Your payment has been processed successfully.
      </p>

      <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 w-full max-w-sm justify-center items-center">
        <button
          onClick={() => navigate('/')}
          className="w-full sm:w-auto bg-green-600 text-white px-5 py-3 rounded-lg hover:bg-green-700 transition shadow-md"
        >
          Go to Homepage
        </button>
      </div>

      <div className="mt-10 text-sm text-gray-400 text-center">
        Thank you for booking with <span className="font-semibold text-green-600">BookTrip4Me</span> ✈️
      </div>
    </div>
  );
};

export default PaymentSuccess;
